import { render, staticRenderFns } from "./BasisSelect.vue?vue&type=template&id=41b4795c&scoped=true"
import script from "./BasisSelect.vue?vue&type=script&lang=js"
export * from "./BasisSelect.vue?vue&type=script&lang=js"
import style0 from "./BasisSelect.vue?vue&type=style&index=0&id=41b4795c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4795c",
  null
  
)

export default component.exports